//#########################################################################
//
// this service enables the use of a bluetooth device with XLogoOnline
// currently it only supports BlueBots.
// It is able to connect, disconnect, and send sequences of commands
//
//#########################################################################
﻿import { Injectable } from "@angular/core";

declare var swal: any;

//constant UUID to detect the necessary services of the BlueBot
const UUID_BLUEBOT_DEVICE_SERVICE = '0000fff0-0000-1000-8000-00805f9b34fb';
const DEVICE_NAME = 'BlueBot';
const DEVICE_PRIMARY_CHAR = '0000fff1-0000-1000-8000-00805f9b34fb';
const DEVICE_PRIMCHAR_DESCRIPTOR = '00002902-0000-1000-8000-00805f9b34fb';
const DEVICE_SECONDARY_CHAR = '0000fff2-0000-1000-8000-00805f9b34fb';

//transforms hex strings to an array buffer (needs to be sent in this form)
const hexToArrayBuffer = require('hex-to-array-buffer')

@Injectable()
export class BluetoothService {

    //BlueBot Bluetooth properties
    private device;
    private primChar;
    private server;
    private service;
    static secChar;

    //Sequence of moves that need yet to be sent to BlueBot
    private moves;
    //Messages to be sent out (frames)
    private messages;

    constructor() {
        this.resetVars();
    }



    //function that returns true if a BlueBot is connected, false otherwise
    checkWhetherBluetoothConnected() {
        return (!(this.device === null));
    }

    //intitial connection setup
    connectBluebot() {
        // Call navigator.bluetooth.requestDevice
        let options = { filters: [{ services: [UUID_BLUEBOT_DEVICE_SERVICE] }] };
        this.device = null;
        console.log('Requesting Bluetooth Device...');
        (<any>navigator).bluetooth.requestDevice(options)
            .then(device => {
                console.log('Connecting to GATT Server...');
                console.log(device)
                this.device = device;
                //listen if BlueBot gets disconnected
                this.device.addEventListener('gattserverdisconnected', this.onDisconnected);

                return device.gatt.connect()
                    .then(server => {
                        this.server = server;
                        console.log('> Bluetooth Device connected');
                    });
            })
            .then(server => {
                //get primary service of the server
                console.log('Getting Service...');
                return this.server.getPrimaryService(UUID_BLUEBOT_DEVICE_SERVICE);
            })
            .then(service => {
                //get primary characteristic of primary service
                console.log('Getting Characteristic...');
                this.service = service;
                return service.getCharacteristic(DEVICE_PRIMARY_CHAR);
            })
            .then(characteristic => {
                //start getting notifications from device
                this.primChar = characteristic;
                return this.primChar.startNotifications()
                    .then(_ => {
                        console.log('> Notifications started');
                        this.primChar.addEventListener('characteristicvaluechanged',
                            this.handleNotifications);
                    });
            })
            .then(service => {
                //get secondary characteristic from primary service
                return this.service.getCharacteristic(DEVICE_SECONDARY_CHAR);
            })
            .then(characteristic => {
                BluetoothService.secChar = characteristic;
            })
            .catch(error => {
                console.log('Argh! ' + error);
            });
    }

    //send a sequence of commands to device
    go() {
        //add "GO" command to the sequence of commands
        this.moves = this.moves + "01";

        //create full message that needs to be sent to device
        this.createMessage();
        console.log("all messages: " + this.messages);
        this.messages.forEach(mes => {
            //send message to device
            BluetoothService.secChar.writeValue(hexToArrayBuffer(mes))

        });
        //reset all message variables to default, to be able to recieve next.
        this.moves = "";
        this.messages = [];
    }

    // create message from sequence of moves
    // Message of the form: aa ?? 82 FF !! XX, where
    //      ?? is the number of bytes in between ?? and XX
    //      FF is the total number of frames and the current frame
    //      !! all commands for device including GO
    //      XX is the checksum of all bytes from ?? to !!
    createMessage() {

        var numFrames = this.framenumber();
        console.log("numframes:" + numFrames);

        for (let i = 1; i <= numFrames; i++) {
            var FF = "" + numFrames + i;
            //take out the first up to 40 commands
            var tempMoves = this.moves.substring(0, 40 * 2)
            this.moves = this.moves.substring(40 * 2)

            //length has to be given in bytes
            var tempMovesLength = tempMoves.length / 2;

            // add 2 bytey as we add "82FF" to commands
            tempMovesLength = tempMovesLength + 2;
            // length as hexadecimal
            var hextempMovesLength = tempMovesLength.toString(16);

            // check if hexadecimal is just one digit
            // if yes, add a 0 in front
            if (tempMovesLength < 16) {
                hextempMovesLength = "0" + hextempMovesLength;
            }

            // put together part of message from which the checksum is calculated, that is "?? 82 FF !!"
            tempMoves = hextempMovesLength + "82" + FF + tempMoves;

            // calculate checksum
            var checksum = this.calc_cksum8(tempMoves);
            // put together final message
            var message = "aa" + tempMoves + checksum;

            this.messages.push(message);
        }
    }

    // #########################################################################################################################################
    //
    // possible commands, that can be sent to BlueBot
    //
    // #########################################################################################################################################

    //add wait command to sequence of commands
    wait() {
        this.moves = this.moves + "03"
    }

    //add "FD" command to sequence of commands
    moveForward() {
        this.moves = this.moves + "04";
    }

    //add "BK" command to sequence of commands
    moveBack() {
        this.moves = this.moves + "05";
    }

    //add "LT 90" command to sequence of commands
    moveLeft90() {
        this.moves = this.moves + "06";
    }

    //add "LT 45" command to sequence of commands
    moveLeft45() {
        this.moves = this.moves + "08";
    }

    //add "RT 90" command to sequence of commands
    moveRight90() {
        this.moves = this.moves + "07";
    }

    //add "RT 45" command to sequence of commands
    moveRight45() {
        this.moves = this.moves + "09";
    }


    // #########################################################################################################################################
    //
    // Message construction helper functions
    //
    // #########################################################################################################################################



    //calculate number of frames needed to send particular sequence of commands saved in this.moves
    framenumber() {
        return (1 + Math.floor(this.moves.length / (40 * 2)))
    }


    //calculate checksum of a hexadecimal string
    calc_cksum8(N) {
        //console.log("number for checksum: " + N)

        // convert input value to upper case
        var strN = new String(N);
        strN = strN.toUpperCase();

        var strHex = new String("0123456789ABCDEF");
        var result = 0;
        var fctr = 16;

        //add up all two digit hexadecimal numbers
        for (let i = 0; i < strN.length; i++) {
            if (strN.charAt(i) == " ") continue;

            var v = strHex.indexOf(strN.charAt(i));
            if (v < 0) {
                result = -1;
                break;
            }
            result += v * fctr;

            if (fctr == 16) fctr = 1;
            else fctr = 16;
        }

        //check sum
        if (result < 0) {
            var strResult = new String("Non-hex character");
        }
        else if (fctr == 1) {
            strResult = new String("Odd number of characters");
        }
        else {
            // Calculate 2's complement
            result = (~(result & 0xff) + 1) & 0xFF;

            strResult = strHex.charAt(Math.floor(result / 16)) + strHex.charAt(result % 16);
        }
        return strResult;
    }


    // #########################################################################################################################################
    //
    // Bluetooth specific helper functions
    //
    // #########################################################################################################################################



    //disconnect device
    disconnect() {
        //check if device already disconnected
        if (!this.device) {
            return;
        }
        console.log('Disconnecting from Bluetooth Device...');
        if (this.device.gatt.connected) {
            this.device.gatt.disconnect();

            //reset all device properties to default
            this.device = null;
            this.primChar = null;
            this.server = null;
            this.service = null;
            this.moves = "";
            this.messages = [];

            //document.getElementById('speed').hidden = false;
        } else {
            console.log('> Bluetooth Device is already disconnected');
        }
    }

    //clean up variables if device disconnects itself
    onDisconnected(event) {
        // Object event.target is Bluetooth Device getting disconnected.
        console.log('> Bluetooth Device disconnected');
        this.device = null;
        this.primChar = null;
        this.server = null;
        this.service = null;
        this.moves = "";
        this.messages = [];

        //document.getElementById('speed').hidden = false;
    }

    //handle recieved notifications from device
    handleNotifications(event) {
        let value = event.target.value;
        let a = [];
        // Convert raw data bytes to hex values just for the sake of showing something.
        // In the "real" world, you'd use data.getUint8, data.getUint16 or even
        // TextDecoder to process raw data bytes.
        for (let i = 0; i < value.byteLength; i++) {
            a.push('0x' + ('00' + value.getUint8(i).toString(16)).slice(-2));
        }
        console.log('> ' + a.join(' '));
    }

    // Reset all variables to zero/null
    resetVars() {
        this.device = null;
        this.primChar = null;
        this.server = null;
        this.service = null;
        this.moves = "";
        this.messages = [];
    }






}



// WEBPACK FOOTER //
// ./src/app/services/bluetooth.service.ts